import { useSelector } from 'react-redux';
import FilterDialog from './Dialog';
import FilterButton from '../../../../../filter/FilterButton';
import {
  SURVEY_TYPE_ABOUT_CLASSES,
  SURVEY_TYPE_ABOUT_USERS,
  SURVEY_TYPE_STANDARD
} from '../../../constants/typeSurvey';

const FilterCompletionButtom = ({ disabled = false, dataYears = [], type = SURVEY_TYPE_STANDARD }) => {
  const open = useSelector((state) => state?.filter?.surveyPreviewList?.open || false);

  return (
    <>
      <FilterButton module='surveyPreviewList' keysFilter={['yearLevelId']} disabled={disabled} />
      {open && !disabled && <FilterDialog dataYears={dataYears} type={type} />}
    </>
  );
};
export default FilterCompletionButtom;
